module.exports = __webpack_public_path__ + "icon-javascript.3S26Rk3R.svg";